import * as d3 from "d3";
import { AXIS_LABEL_SIZE, AXIS_POINT_SIZE } from "../../constants";
import Utils from "../../Utility/Utils";
import D3_Utility from "../../Utility/D3_Utility";
import PolicyScoreGraph from "../PolicyScoreGraph";

export default class MobilePolicyScoreGraph extends D3_Utility {

    constructor(chartArea, data, topCountries, distanceToFrontier) {
        super();
        this.MARGIN = { LEFT: 40, RIGHT: 10, TOP: 20, BOTTOM: 0 };
        this.WIDTH = chartArea.clientWidth;
        this.HEIGHT = window.innerHeight;

        this.chartArea = chartArea
        this.GRAPH_X_START = 0

        this.cacheDOM();

        this.data = data;
        this.topCountries = topCountries
        this.rects = null
        this.legendHeight = null
        this.totalProductivity = 0;
        this.previousValues = {};
        this.distanceToFrontier = distanceToFrontier


        if (!Array.isArray(this.data)) {
            console.error('Invalid data format for dropdown population:', this.data);
            return;
        }

        this.shortCountryName = Utils.SHORT_COUNTRY_NAMES

        this.svg = d3
            .select("#policy-chart-area")
            .append("svg")
            .attr("width", this.WIDTH)

        this.updateGraph('Argentina')

    }

    cacheDOM() {
        this.dropdownElement = document.getElementById("selectCountry2");
        this.country = document.querySelector('#policy-simulator .titleBlock .main_title');
        this.countryFlag = document.querySelector('#policy-simulator .titleBlock img');
        this.baselinePPIPoint = document.querySelector('#policy-simulator .top-row .baselinePPI .point');
        this.baselinePPIDecimal = document.querySelector('#policy-simulator .top-row .baselinePPI .decimal');
        this.improvementScore = document.querySelector('#policy-simulator .top-row .policy_improvement .score');
        this.progressBar = document.querySelector('#policy-simulator .top-row .policy_improvement .progress-bar .progress');
        this.progressSVG = document.querySelector('#policy-simulator .top-row .policy_improvement .progress-score svg');
        this.progressThumb = document.querySelector('#policy-simulator .top-row .policy_improvement .progress-bar .thumb');
        this.productivityPPIPoint = document.querySelector('#policy-simulator .top-row .productivityPPI .point');
        this.productivityPPIDecimal = document.querySelector('#policy-simulator .top-row .productivityPPI .decimal');
        this.legendRow = document.querySelector('#policy-simulator .graph-area .legend-row');
        this.legendGridBox = document.querySelectorAll('#policy-simulator .graph-area .legend-row .legend-grid-box');
        this.countryImage = document.querySelector('#policy-simulator .bottom-row .img-block')
    }

    clearGraph() {
        this.svg.selectAll("*").remove();
        this.legendGridBox.forEach(box => {
            const selectElement = box.querySelector('select');
            if (selectElement) selectElement.remove();
        });
    }

    updateGraph(country) {
        this.clearGraph();
        this.svg.attr('height', this.HEIGHT + 50)

        this.getDTFs = PolicyScoreGraph.getTop3DTF(this.distanceToFrontier, country)
        const filteredData = this.data.filter(d => d.Country === country);
        const actualData = filteredData[0];
        this.dropdownElement.value = country


        // Reorder Categories
        const customOrder = ['Human', 'Physical', 'Innovation', 'Institution', 'Natural', 'Social'];
        const sortedCategories = actualData.Categories.sort((a, b) => {
            return customOrder.indexOf(a.group) - customOrder.indexOf(b.group);
        });


        // HANDLE BOTTOM GRAPH
        if (!actualData || !actualData.Categories) {
            console.error("No data available for the selected country:", country);
            return;
        }

        this.updateHeader(actualData)


        const xScale = d3
            .scaleLinear()
            .domain([d3.min(actualData.Categories, d => d.value) || 0, d3.max(actualData.Categories, d => d.value)])
            .range([this.GRAPH_X_START + 10, this.WIDTH - 20]);

        const yScale = d3
            .scaleBand()
            .domain(actualData.Categories.map((_, i) => i))
            .range([this.MARGIN.TOP, this.HEIGHT - this.MARGIN.BOTTOM])
            .padding(0.5);


        const baseline = xScale(0);

        const colorScale = d3.scaleLinear()
            .domain([d3.max(actualData.Categories, d => d.value), d3.min(actualData.Categories, d => d.value)])  // Use index range from 0 to the number of categories
            .range(["#359FFD", "#00B0FF", "#3F7799"]);

        actualData.Categories.forEach((d, i) => {
            const legendBox = this.legendGridBox[i];
            const mainScore = legendBox.querySelector('.main-score');
            const simulatedScore = legendBox.querySelector('.simulated-score');

            mainScore.textContent = `$${Utils.roundUpToDecimal(d.value, 1)}`;
            mainScore.style.color = "#000"

            if (this.getDTFs.some(item => item.group === d.group)) {
                if (country == 'Luxembourg' && d.group == 'Human') {
                    simulatedScore.style.display = "none";
                    return
                } else {
                    mainScore.style.color = colorScale(i - 1)
                simulatedScore.style.display = "block"
                this.addCompareDropdown(d.group, i, country)

                const compareSelect = document.querySelector(`#compareSelect_${d.group}`)
                compareSelect.addEventListener('change', () => {
                    const group = compareSelect.dataset.group
                    const newValue = compareSelect.value == 'null' ? 0 : parseFloat(compareSelect.value.split(',')[1]) - parseFloat(Utils.roundUpToDecimal(d.value, 1));

                    if (this.previousValues[group] !== undefined) {
                        this.totalProductivity -= this.previousValues[group];
                    }

                    this.totalProductivity += newValue;
                    this.previousValues[group] = newValue;

                    this.updateHeader(actualData)

                    document.querySelector(`#policy-simulator [data-legend-group="${group}"] .simulated-score .point`).textContent = compareSelect.value == 'null' ? 0 : compareSelect.value.split(',')[1]
                    const allCompareDropdown = document.querySelectorAll('#policy-simulator .graph-area .compareSelect')
                    this.reformGraph(allCompareDropdown, actualData, compareSelect)
                })
                }
                
            } else {
                simulatedScore.style.display = "none";
            }
        })




        const totalSegments = actualData.Categories.length;
        const segments = this.legendGridBox

        setTimeout(() => {
            let cumulativeY = 49;

            // BG RECTS
            this.bgRects = this.svg.append('g')
                .attr('class', 'bg-rects-group')
                .selectAll('rect')
                .data(actualData.Categories)
                .join('rect')
                .attr('class', 'bg-rect')
                .attr('width', this.WIDTH)
                .attr('x', 0)
                .attr('fill', d =>
                    (this.getDTFs.some(item => item.group === d.group) && (country !== 'Luxembourg' || d.group !== 'Human'))
                        ? "#F0F8FF"
                        : "#DBEDFF"
                )
                .attr('y', (d, i) => {
                    const yPos = cumulativeY;
                    cumulativeY += segments[i].getBoundingClientRect().height; // Update the cumulative height for the next rectangle
                    return yPos - 2;
                })
                .attr('height', (d, i) => {
                    return segments[i].getBoundingClientRect().height - 1
                })

            this.drawXAxis(xScale)

            let lineY1 = 49
            let lineY2 = 49
            // DASHED LINES STROKE
            this.svg.append('g')
                .attr('class', 'dashed-stroke')
                .selectAll('line')
                .data(actualData.Categories)
                .join("line")
                .attr('x1', 0)
                .attr('x2', this.WIDTH)
                .attr('y1', (d, i) => {
                    ;
                    const yPos = lineY1;
                    lineY1 += segments[i].getBoundingClientRect().height; // Update the cumulative height for the next rectangle
                    return yPos - 2;
                })
                .attr('y2', (d, i) => {
                    const yPos = lineY2;
                    lineY2 += segments[i].getBoundingClientRect().height; // Update the cumulative height for the next rectangle
                    return yPos - 2;
                })
                .attr('stroke', "#C5C7C8")
                .attr('stroke-width', 1)
                .attr('stroke-dasharray', '2,2')


            // DATA RECT
            this.svg
                .append("g")
                .selectAll("rect")
                .data(actualData.Categories)
                .join("rect")
                .attr("x", xScale(0))
                .attr('class', 'data-rect')
                .attr("y", (d, i) => {
                    const centerOfBgRect = this.svg.selectAll('.bg-rect')._groups[0][i].getBBox().height / 2
                    const yPos = this.svg.selectAll('.bg-rect')._groups[0][i].getBBox().y
                    return (yPos + centerOfBgRect) - 7.5
                })
                .attr("height", 15)
                .attr("width", 0)
                .attr("data-label-rect", d => d != null ? d.group : "")
                .attr("opacity", 1)
                .attr('fill', d => (this.getDTFs.some(item => item.group === d.group) && (country !== 'Luxembourg' || d.group !== 'Human'))
                    ? "none"
                    : "#D2E4F6"
                )
                .transition()
                .duration(500)
                .ease(d3.easePoly.exponent(1))
                .attr("x", d => (d ? (d.value >= 0 ? xScale(0) : xScale(d.value)) : xScale(0)))
                .attr("width", d => (d ? Math.abs(xScale(d.value) - xScale(0)) : 0));


            const normalGradient = this.svg.append("defs")
                .append("linearGradient")
                .attr("id", "normalGradient")
                .attr("x1", "0%")  // Start at the left side
                .attr("y1", "0%") // Start from the bottom (100% of the height)
                .attr("x2", "100%")  // End at the left side
                .attr("y2", "0%")  // End at the top (0% of the height)
                .selectAll("stop")
                .data([
                    { offset: "0%", color: "#E6F3FF", opacity: 1 },
                    { offset: "100%", color: "#E6F3FF", opacity: 0 }
                ])
                .enter().append("stop")
                .attr("offset", d => d.offset)
                .attr("stop-color", d => d.color)
                .attr("stop-opacity", d => d.opacity);

            cumulativeY = 49

            this.gradientRects = this.svg
                .append("g")
                .selectAll("rect")
                .data(actualData.Categories)
                .join("rect")
                .attr("x", 0)
                .attr("data-label", d => d != null ? d.group : "")
                .attr('width', 30)
                .attr('y', (d, i) => {
                    const yPos = cumulativeY;
                    cumulativeY += segments[i].getBoundingClientRect().height; // Update the cumulative height for the next rectangle
                    return yPos - 2;
                })
                .attr('height', (d, i) => {
                    return segments[i].getBoundingClientRect().height - 1
                })
                .attr("fill", d => (this.getDTFs.some(item => item.group === d.group) && (country !== 'Luxembourg' || d.group !== 'Human'))
                    ? "none"
                    : "url(#normalGradient)"
                )

            this.xLine = this.svg
                .append("line")
                .attr("y1", this.MARGIN.TOP + 30)
                .attr("y2", this.HEIGHT)
                .attr("x1", baseline > this.HEIGHT - 15 ? this.HEIGHT - 15 : baseline)
                .attr("x2", baseline > this.HEIGHT - 15 ? this.HEIGHT - 15 : baseline)
                .attr("stroke", "#000")
                .attr("stroke-width", 1);

            let leftLineY = 49
            this.leftActiveLine = this.svg.append('g')
                .attr('class', 'left-line-group')
                .selectAll('rect')
                .data(actualData.Categories)
                .join('rect')
                .attr('class', 'left-line')
                .attr('width', 2)
                .attr('x', 0)
                .attr('fill', (d, i) => (this.getDTFs.some(item => item.group === d.group) && (country !== 'Luxembourg' || d.group !== 'Human'))
                    ? colorScale(i)
                    : "none"
                )
                .attr('y', (d, i) => {
                    const yPos = leftLineY;
                    leftLineY += segments[i].getBoundingClientRect().height; // Update the cumulative height for the next rectangle
                    return yPos - 2;
                })
                .attr('height', (d, i) => {
                    return segments[i].getBoundingClientRect().height - 1
                })

            // DATA CIRCLE
            this.svg
                .append("g")
                .selectAll("circle")
                .data(actualData.Categories)
                .join("circle")
                .attr("class", "data-circle")
                .attr("cx", xScale(0))
                .attr("cy", (d, i) => {
                    const centerOfBgRect = this.svg.selectAll('.bg-rect')._groups[0][i].getBBox().height / 2
                    const yPos = this.svg.selectAll('.bg-rect')._groups[0][i].getBBox().y
                    return (yPos + centerOfBgRect)
                })
                .attr("r", 8) // Initial radius is 0 for the animation
                .attr("fill", d => (this.getDTFs.some(item => item.group === d.group) && (country !== 'Luxembourg' || d.group !== 'Human'))
                    ? "#fff"
                    : "rgba(0,0,0,0.1)"
                )
                .attr("stroke", d => (this.getDTFs.some(item => item.group === d.group) && (country !== 'Luxembourg' || d.group !== 'Human'))
                    ? "#000"
                    : "rgba(0,0,0,0.3)"
                )
                .attr("stroke-width", 2)
                .transition() // Apply the animation
                .duration(500) // Animation duration in milliseconds
                .ease(d3.easePoly.exponent(1)) // Optional easing function
                .attr("cx", d => (d ? xScale(d.value) : baseline))

            this.svg.append("g")
                .selectAll("text")
                .data(actualData.Categories) 
                .join("text")
                .attr("class", "data-text")
                .attr("x", 0)
                .attr("y", (d, i) => {
                    const centerOfBgRect = this.svg.selectAll('.bg-rect')._groups[0][i].getBBox().height / 2
                    const yPos = this.svg.selectAll('.bg-rect')._groups[0][i].getBBox().y
                    return (yPos + centerOfBgRect)
                })
                .attr("dy", -15)
                .attr("dx", 0)
                .attr("opacity", 0)
                .attr("fill", "rgba(2, 81, 151, 1)")
                .attr("text-anchor", "middle")
                .attr("font-size", AXIS_LABEL_SIZE + 'px')
                .attr("font-family", "Logical")
                .text(d => (d && d.value !== undefined) ? Utils.roundUpToDecimal(d.value, 1) : '')
                .transition()
                .duration(500)
                .ease(d3.easePoly.exponent(1))
                .attr("x", d => (d && d.value !== undefined) ? xScale(d.value) : baseline)

            this.svg.selectAll(".data-circle")
                .on("mouseenter", function (event, d) {
                    d3.selectAll(".data-text").filter((data) => data === d)
                        .transition()
                        .duration(200)
                        .attr("opacity", 1);
                })
                .on("mouseleave", function (event, d) {
                    d3.selectAll(".data-text").filter((data) => data === d)
                        .transition()
                        .duration(200)
                        .attr("opacity", 0);
                });
        }, 200)

    }

    updateHeader(actualData) {
        if (this.countryFlag && this.country) {
            this.countryFlag.src = `assets/images/Flags/${actualData.Flag}`;
            this.country.textContent = this.shortCountryName[actualData.Country] || actualData.Country;
        }

        const baselinePPI = actualData.Categories.reduce((acc, cum) => acc + cum.value, 0);
        if (this.baselinePPIPoint && this.baselinePPIDecimal) {
            this.baselinePPIPoint.textContent = parseInt(Utils.roundUpToDecimal(baselinePPI, 1));
            this.baselinePPIDecimal.textContent = `.${Utils.extractDecimalDigit(baselinePPI, 1)}`;
        }

        const finalScore = baselinePPI + parseFloat(Utils.roundUpToDecimal(this.totalProductivity, 1))
        if (this.productivityPPIPoint && this.productivityPPIDecimal) {
            this.productivityPPIPoint.textContent = parseInt(Utils.roundUpToDecimal(finalScore, 1))
            this.productivityPPIDecimal.textContent = `.${Utils.extractDecimalDigit(finalScore, 1)}`;
        }

        if (parseFloat(Utils.roundUpToDecimal(this.totalProductivity, 1)) < 0) {
            this.progressSVG.classList.add('negative')
        } else {
            this.progressSVG.classList.remove('negative')
        }


        if (this.improvementScore) {
            this.improvementScore.textContent = `$${0 + parseFloat(Utils.roundUpToDecimal(this.totalProductivity, 1))}`
        }

        const regionEncoded = encodeURIComponent(actualData.Region);
        const countryEncoded = encodeURIComponent(actualData.Country);

        this.countryImage.style.backgroundImage = `url(assets/images/country_images/${regionEncoded}/${countryEncoded}.webp)`
    }

    drawXAxis(xScale) {
        this.svg.selectAll('.x-axis').remove()
        this.svg.selectAll('.x-axis-line').remove()

        this.svg.append("g")
            .attr("class", 'x-axis')
            .attr("transform", `translate(0, ${this.MARGIN.TOP + 10})`)
            .call(d3.axisTop(xScale).ticks(5).tickSize(0).tickPadding(0))
            .selectAll("path, line, text")
            .style('font-size', AXIS_LABEL_SIZE)
            .style("stroke", "none");

        this.svg.append("g")
            .selectAll("line")
            .data(xScale.ticks(5))
            .join("line")
            .attr('class', `x-axis-line`)
            .attr("x2", d => xScale(d))
            .attr("x1", d => xScale(d))
            .attr("y1", this.MARGIN.TOP + 30)
            .attr("y2", this.HEIGHT)
            .attr("stroke", 'rgba(225, 227, 228, 1)')
            .attr("stroke-dasharray", "2,2")
            .attr("stroke-width", 1);

        // this.svg.append("g")
        //     .attr("class", "y-axis")
        //     .attr("transform", `translate(${this.MARGIN.LEFT}, 0)`)
        //     .call(d3.axisLeft(yScale).ticks(5).tickSize(0).tickPadding(0))
        //     .selectAll("path, line")
        //     .style("stroke", "none");

        // this.svg.append("g")
        //     .selectAll("line")
        //     .data(yScale.ticks(5))
        //     .join("line")
        //     .attr('class', 'y-axis-line')
        //     .attr("x1", this.MARGIN.LEFT)
        //     .attr("x2", this.WIDTH)
        //     .attr("y1", d => yScale(d))
        //     .attr("y2", d => yScale(d))
        //     .attr("stroke", "rgba(225, 227, 228, 1)")
        //     .attr("stroke-dasharray", "2,2")
        //     .attr("stroke-width", 1);
    }

    reformGraph(allCompareDropdown, actualData, thisDropdown) {
        const compareDropdownArr = [];
        allCompareDropdown.forEach(dropdown => {
            if (dropdown.value !== 'null') {
                const val = dropdown.value.split(',');
                compareDropdownArr.push({ group: dropdown.dataset.group, country: val[0], value: parseFloat(val[1]) });
            } else {
                compareDropdownArr.push({ group: dropdown.dataset.group, country: null, value: null });
            }
        });

        const thisGroup = thisDropdown.dataset.group

        if (!actualData || !actualData.Categories) {
            console.error("No data available for the selected country.");
            return;
        }

        const maxOriginalValueObj = actualData.Categories.reduce((max, current) => {
            return (current.value > max.value) ? current : max;
        }, actualData.Categories[0]);

        const maxNewValueObj = compareDropdownArr.reduce((max, current) => {
            return (current.value > max.value) ? current : max;
        }, compareDropdownArr[0]);

        // Get the overall maximum value
        const maxValueObj = maxOriginalValueObj.value > maxNewValueObj.value ? maxOriginalValueObj : maxNewValueObj;
        const maxValue = maxValueObj.value;

        const minValue = d3.min(actualData.Categories, d => d.value)
        const xScale = d3.scaleLinear()
            .domain([minValue, maxValue])
            .range([this.GRAPH_X_START + 10, this.WIDTH - 20]);

        this.drawXAxis(xScale);

        this.removeSVGElements()

        const grayRecyGradient = this.svg.append("defs")
            .append("linearGradient")
            .attr("id", "grayRecyGradient")
            .attr("x1", "0%")  // Start at the left side
            .attr("y1", "0%") // Start from the bottom (100% of the height)
            .attr("x2", "100%")  // End at the left side
            .attr("y2", "0%")  // End at the top (0% of the height)
            .selectAll("stop")
            .data([
                { offset: "0%", color: "#D2E4F6", opacity: 0 }, // White at the bottom
                { offset: "50%", color: "#D2E4F6", opacity: 0.8 }, // White at the bottom
                { offset: "100%", color: "#D2E4F6", opacity: 1 } // Transparent at the top
            ])
            .enter().append("stop")
            .attr("offset", d => d.offset)
            .attr("stop-color", d => d.color)
            .attr("stop-opacity", d => d.opacity);

        this.svg
            .append("g")
            .attr('class', 'expanded-data-rect-group')
            .selectAll("rect")
            .data(actualData.Categories)
            .join("rect")
            .attr('class', 'expanded-data-rect')
            .attr("x", xScale(0))
            .attr("data-label-rect", d => d != null ? d.group : "")
            .attr("y", (d, i) => {
                const centerOfBgRect = this.svg.selectAll('.bg-rect')._groups[0][i].getBBox().height / 2
                const yPos = this.svg.selectAll('.bg-rect')._groups[0][i].getBBox().y
                return (yPos + centerOfBgRect) - 7.5
            }) // Start at the baseline (0) 
            .attr("height", 15) // Initial height is 0 for the animation
            .attr("width", 0)
            .attr("fill", d => this.getDTFs.some(item => item.group === d.group) ? "none" : "url(#grayRecyGradient)")
            .attr("opacity", 1)
            .transition()
            .duration(500)
            .ease(d3.easePoly.exponent(1)) // Apply easing to the transition
            .attr("x", d => (d ? (d.value >= 0 ? xScale(0) : xScale(d.value)) : xScale(0))) // Adjust for negative values
            .attr("width", d => Math.abs(xScale(d.value) - xScale(0)))

        const rectGradient = this.svg.append("defs")
            .attr('class', 'expanded-defs')
            .append("linearGradient")
            .attr("id", "rectGradient")
            .attr("x1", "0%")  // Start at the left side
            .attr("y1", "0%") // Start from the bottom (100% of the height)
            .attr("x2", "100%")  // End at the left side
            .attr("y2", "0%")  // End at the top (0% of the height)
            .selectAll("stop")
            .data([
                { offset: "0%", color: "rgba(179, 219, 254, 1)", opacity: 0 }, // White at the bottom
                { offset: "100%", color: "rgba(179, 219, 254, 1)", opacity: 1 } // Transparent at the top
            ])
            .enter().append("stop")
            .attr("offset", d => d.offset)
            .attr("stop-color", d => d.color)
            .attr("stop-opacity", d => d.opacity);

        this.svg
            .append("g")
            .attr('class', 'expanded-circle-group')
            .selectAll("circle")
            .data(actualData.Categories)
            .join("circle")
            .attr("class", "data-circle")
            .attr("cx", xScale(0))
            .attr("cy", (d, i) => {
                const centerOfBgRect = this.svg.selectAll('.bg-rect')._groups[0][i].getBBox().height / 2
                const yPos = this.svg.selectAll('.bg-rect')._groups[0][i].getBBox().y
                return (yPos + centerOfBgRect)
            }) // Start at the baseline (0)
            .attr("r", 8) // Initial radius is 0 for the animation
            .attr("fill", d => {
                const match = compareDropdownArr.find(obj => obj.group === d.group);
                return match ? "#fff" : "rgba(0,0,0,0.1)";
            })
            .attr("stroke", "rgba(0,0,0,0.3)") // Stroke color for the circles
            .attr("stroke-width", 2)
            .style("position", "relative")
            .style("z-index", 45)  // Ensure the circles are above bars
            .transition() // Apply the animation
            .duration(500) // Animation duration in milliseconds
            .ease(d3.easePoly.exponent(1)) // Optional easing function
            .attr("cx", d => (d ? xScale(d.value) : xScale(0)))

        this.svg.append("g")
            .attr("class", "expanded-data-text")
            .selectAll("text")
            .data(actualData.Categories)
            .join("text")
            .attr("class", "data-text")
            .attr("x", xScale(0))
            .attr("y", (d, i) => {
                const centerOfBgRect = this.svg.selectAll('.bg-rect')._groups[0][i].getBBox().height / 2
                const yPos = this.svg.selectAll('.bg-rect')._groups[0][i].getBBox().y
                return (yPos + centerOfBgRect)
            })
            .attr("dy", -15)
            .attr("dx", 0)
            .attr("opacity", 0)
            .attr("fill", "rgba(2, 81, 151, 1)")
            .attr("text-anchor", "middle")
            .attr("font-size", AXIS_LABEL_SIZE + 'px')
            .attr("font-family", "Logical")
            .text(d => (d && d.value !== undefined) ? Utils.roundUpToDecimal(d.value, 1) : '')
            .transition()
            .duration(500)
            .ease(d3.easePoly.exponent(1))
            .attr("x", d => (d && d.value !== undefined) ? xScale(d.value) : xScale(0))

        this.svg.selectAll(".data-circle")
            .on("mouseenter", function (event, d) {
                d3.selectAll(".data-text").filter((data) => data === d)
                    .transition()
                    .duration(200)
                    .attr("opacity", 1);
            })
            .on("mouseleave", function (event, d) {
                d3.selectAll(".data-text").filter((data) => data === d)
                    .transition()
                    .duration(200)
                    .attr("opacity", 0);
            });

        this.xLine
            .attr("x1", xScale(0) > this.WIDTH ? this.WIDTH : xScale(0))
            .attr("x2", xScale(0) > this.WIDTH ? this.WIDTH : xScale(0))

        setTimeout(() => {
            compareDropdownArr.forEach(ar => {
                if (ar.value) {
                    const floatValue = ar.value;
                    const previousBar = this.svg.select(`rect[data-label-rect="${ar.group}"]`)._groups[0][0];
                    const previousBarBBox = previousBar.getBBox();

                    const previousBarData = actualData.Categories.find(obj => obj.group === ar.group)

                    const startX = xScale(previousBarData.value);
                    const finalX = xScale(floatValue);
                    const barWidth = Math.abs(finalX - startX);

                    const barDiff = Utils.roundUpToDecimal(floatValue - parseFloat(Utils.roundUpToDecimal(previousBarData.value, 1)), 1)

                    // EXPANDED DATA BAR
                    this.svg.append("rect")
                        .attr('id', `${ar.group}_bar`)
                        .attr('height', 15)
                        .attr('x', barDiff < 0 ? finalX : startX)
                        .attr('class', 'expanded-bar')
                        .attr('fill', "url(#rectGradient)")
                        .style("transform-origin", "bottom")
                        .attr('y', () => {
                            const boxCenter = previousBarBBox.height / 2;
                            return previousBarBBox.y + boxCenter - 7.5;
                        })
                        .attr('width', 0)
                        .style("position", "relative")
                        .style("z-index", 33)
                        .transition()
                        .duration(500)
                        .ease(d3.easePoly.exponent(1))
                        .attr('width', barWidth);

                    // EXPANDED DATA CIRCLE
                    this.svg
                        .append("circle")
                        .attr('class', 'expanded-circle')
                        .attr("cy", (d, i) => {
                            const boxCenter = previousBarBBox.height / 2;
                            return previousBarBBox.y + boxCenter;
                        })
                        .attr("cx", startX)
                        .attr("r", 8)
                        .attr("fill", "rgba(104, 183, 253, 1)")
                        .attr("stroke", "rgba(2, 108, 202, 1)")
                        .attr("stroke-width", 2)
                        .style("position", "relative")
                        .style("z-index", 44)
                        .transition()
                        .duration(500)
                        .ease(d3.easePoly.exponent(1))
                        .attr("cx", finalX);

                    // EXPANDED DATA LABEL 
                    this.svg.append("text")
                        .attr("class", "expanded-text")
                        .attr("y", (d, i) => {
                            const boxCenter = previousBarBBox.height / 2;
                            return previousBarBBox.y + boxCenter;
                        })
                        .attr("x", startX)
                        .attr("dx", 0)
                        .attr("dy", -15)
                        .attr("fill", "rgba(2, 81, 151, 1)")
                        .attr("text-anchor", "middle")
                        .attr("font-size", AXIS_LABEL_SIZE + 'px')
                        .attr("font-family", "Logical")
                        .text(floatValue)
                        .transition()
                        .duration(500)
                        .ease(d3.easePoly.exponent(1))
                        .attr("x", finalX)

                    // EXPANDED WHITE CONTEXT BG
                    const whiteBG = this.svg.append("rect")
                        .attr('id', `${ar.group}_content_BG`)
                        .attr('height', (this.HEIGHT / 10) / 2)
                        .attr('y', () => {
                            const boxCenter = previousBarBBox.height / 2;
                            return previousBarBBox.y + boxCenter + 15;
                        })
                        .attr('class', 'expanded-content_BG')
                        .attr('fill', "#fff")
                        .style("transform-origin", "bottom")
                        .attr('x', startX)
                        .attr('width', 0)
                        .style("position", "relative")
                        .style("z-index", 33)
                        .transition()
                        .duration(500)
                        .ease(d3.easePoly.exponent(1))
                        .attr('x', () => {
                            if (parseFloat(Utils.roundUpToDecimal(this.totalProductivity, 1)) < 0) {
                                return finalX
                            } else {
                                return startX
                            }
                        })
                        .attr('width', barWidth);

                    // EXPANDED CONTEXT TEXT
                    const textElement = this.svg.append("text")
                        .attr('id', `${ar.group}_double_line_text`)
                        .attr('class', 'double_line_text')
                        .attr("y", () => {
                            const boxCenter = previousBarBBox.height / 2;
                            return previousBarBBox.y + boxCenter + 20;
                        })
                        .attr("x", previousBarBBox.x)
                        .attr("dx", 0)
                        .attr("text-anchor", "left")
                        .attr("font-size", AXIS_POINT_SIZE + 'px')
                        .attr("font-family", "'Logical', Arial, sans-serif")
                        .attr("fill", "rgba(2, 108, 202, 1)")
                        .style("z-index", 32)
                        .style("position", "relative")
                        .style("opacity", 1);

                    textElement.append("tspan")
                        .attr("y", () => {
                            const boxCenter = previousBarBBox.height / 2;
                            return previousBarBBox.y + boxCenter + 30;
                        })
                        .attr("dx", 0)
                        .text("Distance");

                    textElement.append("tspan")
                        .attr("y", () => {
                            const boxCenter = previousBarBBox.height / 2;
                            return previousBarBBox.y + boxCenter + 43;
                        })
                        .attr("dx", -40)
                        .text("to frontier");

                    textElement.transition()
                        .duration(500)
                        .ease(d3.easePoly.exponent(1))
                        .style("opacity", 1);

                    textElement.transition()
                        .duration(500)
                        .ease(d3.easePoly.exponent(1))
                        .attr("x", () => {
                            const center = this.WIDTH / 2
                            return center - 50
                        })

                    // DIFFRENCE VALUE
                    this.svg.append("text")
                        .attr("class", "expanded-text")
                        .attr("y", () => {
                            const boxCenter = previousBarBBox.height / 2;
                            return previousBarBBox.y + boxCenter + 40;
                        })
                        .attr("x", previousBarBBox.x)
                        .attr("fill", "rgba(2, 108, 202, 1)")
                        .attr("text-anchor", "left")
                        .attr("font-size", `${AXIS_LABEL_SIZE + 5}px`)
                        .attr("font-family", "Arial")
                        .text(`$${barDiff}`)
                        .attr("opacity", 0)
                        .transition()
                        .duration(500)
                        .ease(d3.easePoly.exponent(1))
                        .attr("opacity", 1)
                        .attr("x", () => {
                            const center = this.WIDTH / 2
                            return center + 5
                        })

                    // LEFT CHEVRON
                    this.svg.append("polygon")
                        .attr('id', `${ar.group}_chevron`)
                        .attr('points', (d) => {
                            const boxCenter = previousBarBBox.height / 2;
                            const rectY = previousBarBBox.y + boxCenter + 12.5;  // Adjust to shift it to the left
                            const rectX = previousBarBBox.x + 5;  // Start position
                            const chevronWidth = 5;

                            // Define points for the chevron shape (left-pointing)
                            const points = [
                                [rectX, rectY], // Left corner of the chevron (start)
                                [rectX, rectY + chevronWidth], // Peak of the chevron (shift left)
                                [rectX - 5, rectY + 2.5], // Right corner of the chevron (end, shifted left)
                            ];

                            return points.map(d => d.join(",")).join(" ");
                        })
                        .attr('class', 'expanded-chevron')
                        .attr('fill', "rgba(33, 64, 92, 1)")
                        .style("z-index", 34)  // Ensure the chevron is just above the rectangle
                        .style("position", "relative")
                        .transition()
                        .duration(500)
                        .ease(d3.easePoly.exponent(1))
                        .attr('points', (d) => {
                            const boxCenter = previousBarBBox.height / 2;
                            const rectY = previousBarBBox.y + boxCenter + 12.5;  // Adjust to shift it to the left
                            const rectX = startX + 5;  // Start position
                            const chevronWidth = 5; // Height of the chevron (triangle)

                            // Define points for the chevron shape (left-pointing)
                            const points = [
                                [rectX, rectY], // Left corner of the chevron (start)
                                [rectX, rectY + chevronWidth], // Peak of the chevron (shift left)
                                [rectX - 5, rectY + 2.5], // Right corner of the chevron (end, shifted left)
                            ];

                            return points.map(d => d.join(",")).join(" ");
                        });

                    // RIGHT CHEVRON
                    this.svg.append("polygon")
                        .attr('id', `${ar.group}_chevron`)
                        .attr('points', (d) => {
                            const boxCenter = previousBarBBox.height / 2;
                            const rectY = previousBarBBox.y + boxCenter + 12.5;  // Adjust to shift it to the left
                            const rectX = previousBarBBox.x + 5;  // Start position
                            const chevronWidth = 5;

                            // Define points for the chevron shape (left-pointing)
                            const points = [
                                [rectX, rectY], // Left corner of the chevron (start)
                                [rectX, rectY + chevronWidth], // Peak of the chevron (shift left)
                                [rectX - 5, rectY + 2.5], // Right corner of the chevron (end, shifted left)
                            ];

                            return points.map(d => d.join(",")).join(" ");
                        })
                        .attr('class', 'expanded-chevron')
                        .attr('fill', "rgba(33, 64, 92, 1)")
                        .style("z-index", 34)  // Ensure the chevron is just above the rectangle
                        .style("position", "relative")
                        .transition()
                        .duration(500)
                        .ease(d3.easePoly.exponent(1))
                        .attr('points', (d) => {
                            const boxCenter = previousBarBBox.height / 2;
                            const rectY = previousBarBBox.y + boxCenter + 12.5;  // Adjust to shift it to the left
                            const rectX = finalX - 5;  // Start position
                            const chevronWidth = 5; // Height of the chevron (triangle)

                            // Define points for the chevron shape (left-pointing)
                            const points = [
                                [rectX, rectY], // Left corner of the chevron (start)
                                [rectX, rectY + chevronWidth], // Peak of the chevron (shift left)
                                [rectX + 5, rectY + 2.5], // Right corner of the chevron (end, shifted left)
                            ];

                            return points.map(d => d.join(",")).join(" ");
                        });

                    // DOTTED CHEVRON LINE
                    this.svg.append("line")
                        .attr('id', `${ar.group}_dotted_line`)
                        .attr('y1', () => {
                            const boxCenter = previousBarBBox.height / 2;
                            return previousBarBBox.y + boxCenter + 15;  // Same position as the chevron
                        })
                        .attr('x1', startX)  // Start at the y position of the previous bar
                        .attr('y2', () => {
                            const boxCenter = previousBarBBox.height / 2;
                            return previousBarBBox.y + boxCenter + 15;  // Same position as the chevron 
                        })
                        .attr('class', 'expanded_dotted_line')
                        .attr('x2', startX)  // Start at the y position of the previous bar
                        .attr('stroke', "rgba(33, 64, 92, 1)")  // Set the line color
                        .attr('stroke-width', 1)  // Line thickness
                        .attr('stroke-dasharray', "2,2")  // Dotted line (2px dash, 2px gap)
                        .style("z-index", 33)  // Ensure the line is below the chevron and content
                        .style("position", "relative")
                        .transition()  // Start the transition
                        .duration(500)  // Duration of the animation
                        .ease(d3.easePoly.exponent(1))  // Easing function for smoothness
                        .attr('x2', finalX);

                }
            })
        }, 500)
    }

    addCompareDropdown(data, index, currentCountry) {
        const selectDropdown = document.createElement('select')
        selectDropdown.setAttribute('class', 'compareSelect')
        selectDropdown.setAttribute('id', 'compareSelect_' + data)
        selectDropdown.setAttribute('data-group', data)
        const option = document.createElement('option');
        option.setAttribute('selected', true)
        option.textContent = 'Select country'
        option.value = null
        selectDropdown.appendChild(option);

        this.topCountries.forEach(d => {
            if (d.group == data) {
                d.topCountries.forEach(country => {
                    if (currentCountry == 'Luxembourg' && country.country == 'Norway') {
                        return
                    }
                    if (country.country != currentCountry) {
                        const option = document.createElement('option');
                        option.value = [country.country, Utils.roundUpToDecimal(country.sum, 1)];
                        option.textContent = country.country;
                        selectDropdown.appendChild(option);
                    }
                })
            }
        })



        this.legendGridBox[index].appendChild(selectDropdown)
    }


    resetGraph() {
        const dropdowns = document.querySelectorAll('.compareSelect');
        if (dropdowns.length === 0) {
            console.warn('No dropdowns found to reset.');
            return;
        }
        dropdowns.forEach(dropdown => {
            dropdown.value = 'null';  // Reset dropdown value
        });

        this.removeSVGElements()
        document.querySelectorAll(`#policy-simulator .simulated-score .point`).forEach(point => point.textContent = 0)
        this.totalProductivity = 0
        this.previousValues = {}
        this.updateGraph(this.dropdownElement.value)
    }

    removeSVGElements() {
        this.svg.selectAll('.data-rect').remove();
        this.svg.selectAll('.data-text').remove();
        this.svg.selectAll('.data-circle').remove();

        this.svg.selectAll('.expanded-data-rect-group').remove();
        this.svg.selectAll('.expanded-circle-group').remove();
        this.svg.selectAll('.expanded-defs').remove();
        this.svg.selectAll('.expanded-data-text').remove();


        this.svg.selectAll('.expanded-bar').remove();
        this.svg.selectAll('.expanded-circle').remove();
        this.svg.selectAll('.expanded-text').remove();
        this.svg.selectAll('.expanded-content_BG').remove();
        this.svg.selectAll('.expanded-chevron').remove();
        this.svg.selectAll('.expanded_dotted_line').remove();
        this.svg.selectAll('.double_line_text').remove();
    }


}